export default "__VITE_ASSET__$eAKV2nq__"